var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRss = function SvgRss(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.436,11.259C6.436,10.322 5.657,9.545 4.718,9.545C3.752,9.545 3,10.322 3,11.259C3,12.223 3.752,12.973 4.718,12.973C5.657,12.973 6.436,12.223 6.436,11.259ZM11.133,12.545C10.918,8.394 7.59,5.073 3.429,4.859C3.188,4.832 3,5.046 3,5.287L3,6.573C3,6.787 3.161,6.974 3.376,7.001C6.382,7.189 8.797,9.599 8.985,12.598C9.012,12.813 9.2,12.973 9.415,12.973L10.703,12.973C10.945,12.973 11.159,12.786 11.133,12.545ZM14.998,12.545C14.783,6.278 9.737,1.217 3.429,1.003C3.188,0.976 3,1.163 3,1.431L3,2.716C3,2.931 3.161,3.118 3.403,3.145C8.529,3.332 12.662,7.457 12.85,12.572C12.877,12.813 13.065,13 13.28,13L14.568,13C14.836,12.973 15.024,12.786 14.998,12.545Z",
    fill: "#f37500",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRss, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rss.2399aeec.svg";
export { ForwardRef as ReactComponent };